














import { Vue, Component } from 'vue-property-decorator';
import { VbLoadingComponent } from '@/shared/loading/loading.component.vue';
import { VbSnackbarComponent } from '@/shared/snackbar/snackbar.component.vue';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import HeaderComponent from '@/shared/menu-header/menu-header.component.vue';
import MenuComponent from '@/shared/menu-header/menu.component.vue';
import AuthenticationService from './domain/security/authentication.service';
import AuthorityService from './domain/security/authority.service';

@Component({
  components: {
    HeaderComponent,
    MenuComponent,
    VbLoadingComponent,
    VbSnackbarComponent,
  },
})
export default class App extends Vue {
  sidebarOpen: boolean = localStorage.getItem('sidebarOpen') !== 'false';

  toggleSidebar(): void {
    this.sidebarOpen = !this.sidebarOpen;
    localStorage.setItem('sidebarOpen', String(this.sidebarOpen));
  }

  created() {
    // @ts-ignore
    AuthenticationService.msal = this.$msal;
    if (!this.isAuthenticated) {
      AuthenticationService.login();
    }
    this.validatePermissions();
    UserBusinessUnitService.initSelectedBusinessUnit()
  }

  private get isAuthenticated(): boolean {
    return AuthenticationService.isAuthenticated();
  }

  private validatePermissions(): void {
    AuthorityService.authorities().then((response) => {
      if (response.length === 0) {
        this.$router.push('/access-denied');
      }
    });
  }
}
